module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-48.2fc90bef.png";